import button from './SaveButton.vue'
const SaveButton = {
  install: function (Vue) {
    Vue.component('SaveButton', button)
  }
}
export default SaveButton
